module.exports = __webpack_public_path__ + "img/logo-my-balance.ff6a6122.jpg";